<template>
    <div>
        <rkm-overlay :show="loading">
            <rkm-form
                ref="RkmForm"
                show-legend
            >
                <rkm-row>
                    <rkm-col cols="2">
                        <rkm-form-input
                            :validations="validations.cpf_numero"
                            @blur="handleCpfBlur"
                            label="CPF"
                            v-mask="utils.mask.cpf"
                            v-model="model.cpf_numero"
                        />
                    </rkm-col>

                    <rkm-col cols="10">
                        <rkm-form-input
                            :validations="validations.nome"
                            label="Nome"
                            v-model="model.nome"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col>
                        <rkm-form-datepicker
                            :max-date="additionals.data_atual"
                            :validations="validations.data_nascimento"
                            label="Data de nascimento"
                            v-model="model.data_nascimento"
                        />
                    </rkm-col>

                    <rkm-col>
                        <rkm-form-select
                            :options="form.sexos"
                            :validations="validations.sexo_id"
                            label="Sexo"
                            show-default-option
                            text-field="descricao"
                            v-model="model.sexo_id"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="4">
                        <rkm-form-input
                            :validations="validations.telefone_residencial"
                            label="Telefone residencial"
                            v-mask="utils.mask.telefone"
                            v-model="model.telefone_residencial"
                        />
                    </rkm-col>

                    <rkm-col cols="4">
                        <rkm-form-input
                            :validations="validations.telefone_celular"
                            label="Telefone celular"
                            v-mask="utils.mask.celular"
                            v-model="model.telefone_celular"
                        />
                    </rkm-col>

                    <rkm-col cols="4">
                        <rkm-form-input
                            :validations="validations.telefone_recado"
                            label="Telefone de recado"
                            v-mask="utils.mask.telefone"
                            v-model="model.telefone_recado"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-input
                            :validations="validations.email"
                            label="E-mail"
                            v-model="model.email"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-input
                            :disabled="!!id"
                            :validations="validations.login"
                            label="Usuário"
                            v-model="model.login"
                        />
                    </rkm-col>
                </rkm-row>
            </rkm-form>
        </rkm-overlay>
    </div>
</template>

<script>
// Mixins.
import {error} from '@/mixins'

// Others.
import moment from 'moment'

// Utils.
import format from '@/utils/format'
import mask from '@/utils/mask'
import unmask from '@/utils/unmask'

// Vee validate rules.
import cpf from '@/plugins/vee-validate/rules/cpf'

// Vuex.
import {mapActions, mapGetters} from 'vuex'

export default {
    computed: {
        ...mapGetters(['getLoading']),
        loading() {
            return this.getLoading('cadastro-usuario-form')
        },
        validations() {
            return {
                sexo_id: {required: true},
                cpf_numero: {
                    required: true,
                    cpf: true,
                },
                nome: {
                    required: true,
                    min: 3,
                    max: 100,
                },
                data_nascimento: {required: true},
                telefone_residencial: {
                    required: !this.model.telefone_celular && !this.model.telefone_recado,
                    min: 14,
                    max: 14,
                },
                telefone_celular: {
                    required: !this.model.telefone_residencial && !this.model.telefone_recado,
                    min: 15,
                    max: 15,
                },
                telefone_recado: {
                    required: !this.model.telefone_residencial && !this.model.telefone_celular,
                    min: 14,
                    max: 14,
                },
                email: {
                    required: true,
                    email: true,
                    max: 100,
                },
                login: {
                    required: true,
                    min: 5,
                    max: 100,
                },
            }
        },
    },
    data: () => ({
        additionals: {
            data_atual: null,
        },
        form: {
            sexos: [],
        },
        model: {
            sexo_id: null,
            cpf_numero: null,
            nome: null,
            data_nascimento: null,
            telefone_residencial: null,
            telefone_celular: null,
            telefone_recado: null,
            email: null,
            login: null,
            senha: null,
        },
        others: {cpf, moment},
        utils: {
            format,
            mask,
            unmask,
        },
    }),
    inject: ['repositories'],
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            this.setLoading('cadastro-usuario-form')

            if (this.id) {
                this.repositories.cadastro.usuario.edit(this.id)
                    .then(({data}) => {
                        this.additionals = data.additionals
                        this.form = data.form
                        this.model = data.model
                        this.model.cpf_numero = this.utils.format.cpf(this.model.cpf_numero)
                        this.model.telefone_residencial = this.utils.format.telefone(this.model.telefone_residencial)
                        this.model.telefone_celular = this.utils.format.celular(this.model.telefone_celular)
                        this.model.telefone_recado = this.utils.format.telefone(this.model.telefone_recado)
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading('cadastro-usuario-form'))
            } else {
                this.repositories.cadastro.usuario.create()
                    .then(({data}) => {
                        this.additionals = data.additionals
                        this.form = data.form
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading('cadastro-usuario-form'))
            }
        },
        save() {
            this.$refs.RkmForm.validate()
                .then(validated => {
                    if (validated) {
                        this.setLoading('cadastro-usuario-form')

                        const request = {...this.model}

                        request.cpf_numero = this.utils.unmask.cpf(request.cpf_numero)
                        request.data_nascimento = this.others.moment(request.data_nascimento).format('YYYY-MM-DD')
                        request.telefone_residencial = this.utils.unmask.telefone(request.telefone_residencial) || null
                        request.telefone_celular = this.utils.unmask.telefone(request.telefone_celular) || null
                        request.telefone_recado = this.utils.unmask.telefone(request.telefone_recado) || null

                        if (this.id) {
                            this.repositories.cadastro.usuario.update(request, this.id)
                                .then(({data}) => this.$emit('save', data))
                                .catch(this.handleError)
                                .finally(() => this.unsetLoading('cadastro-usuario-form'))
                        } else {
                            this.repositories.cadastro.usuario.store(request)
                                .then(({data}) => this.$emit('save', data))
                                .catch(this.handleError)
                                .finally(() => this.unsetLoading('cadastro-usuario-form'))
                        }
                    }
                })
        },
    },
    mixins: [error],
    mounted() {
        this.load()
    },
    props: {
        id: {type: Number},
    },
}
</script> 